require("!!/Users/mattijsnaus/Documents/code/pagestead/node_modules/script-loader/addScript.js")(require("!!/Users/mattijsnaus/Documents/code/pagestead/node_modules/raw-loader/index.js!/Users/mattijsnaus/Documents/code/pagestead/assets/js/vendor/spectrum.js"))


//////////////////
// WEBPACK FOOTER
// ./node_modules/script-loader!./assets/js/vendor/spectrum.js
// module id = 43
// module chunks = 0 4